import React from 'react'
import { observer } from 'mobx-react'
import {
    StatusDropdownContainer,
    StatusDropdownHeader,
    StatusDropdownBody,
    StatusOption,
    StatusCheckbox,
    StatusLabel,
    StatusDescription
} from './StatusDropdown.styles'
import { CheckboxCheckmarkIcon, ProcessingIcon, CompleteIcon } from './icons'

const statusOptions = [
    {
        id: 'Processing',
        label: 'In progress',
        description: 'Files are in deep analysis process, this might take up to 24h.',
        type: 'processing',
        color: '#F1F3F5'
    },
    {
        id: 'Done',
        label: 'Completed',
        description: 'Deep analysis process has completed and your portfolio was updated.',
        type: 'complete',
        color: '#72E1AC'
    }
]

export const StatusDropdown = observer(({ selectedStatuses = [], onStatusSelect }) => {
    const isStatusSelected = (statusId) => {
        return selectedStatuses.some(status => status.id === statusId || status === statusId)
    }

    const handleStatusClick = (status) => {
        onStatusSelect(status.id, status.label)
    }

    const renderStatusIcon = (status) => {
        if (status.type === 'processing') {
            return <ProcessingIcon />
        } else {
            return (
                <span style={{
                    width: '16px',
                    height: '16px',
                    backgroundColor: status.color,
                    borderRadius: '50%',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <CompleteIcon />
                </span>
            )
        }
    }

    return (
        <StatusDropdownContainer onClick={(e) => e.stopPropagation()}>
            <StatusDropdownHeader>
                Select status
            </StatusDropdownHeader>
            <StatusDropdownBody>
                {statusOptions.map(status => (
                    <StatusOption
                        key={status.id} 
                        onClick={() => handleStatusClick(status)}
                    >
                        <StatusCheckbox>
                            <input
                                type="checkbox"
                                checked={isStatusSelected(status.id)}
                                readOnly
                            />
                            <span className="checkmark">
                                {isStatusSelected(status.id) ? <CheckboxCheckmarkIcon /> : null}
                            </span>
                        </StatusCheckbox>
                        <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                            <StatusLabel>{renderStatusIcon(status)}{status.label}</StatusLabel>
                            <StatusDescription>{status.description}</StatusDescription>
                        </div>
                    </StatusOption>
                ))}
            </StatusDropdownBody>
        </StatusDropdownContainer>
    )
})